import { app } from "@/config/env";
import {
  logEvent as fbLogEvent,
  getAnalytics,
  setUserId,
  setUserProperties,
} from "firebase/analytics";
import type { FirebaseApp } from "firebase/app";
import { getApps, initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: app.FIREBASE.API_KEY,
  authDomain: app.FIREBASE.AUTH_DOMAIN,
  projectId: app.FIREBASE.PROJECT_ID,
  storageBucket: app.FIREBASE.STORAGE_BUCKET,
  messagingSenderId: app.FIREBASE.MESSAGING_SENDER_ID,
  appId: app.FIREBASE.APP_ID,
  measurementId: app.FIREBASE.MEASUREMENT_ID,
};

// Initialize Firebase as a Singleton
let firebaseApp: FirebaseApp;
let firebaseAnalytics: ReturnType<typeof getAnalytics> | null | undefined;

export function getFirebaseApp(): FirebaseApp {
  if (!firebaseApp) {
    if (getApps().length === 0) {
      firebaseApp = initializeApp(firebaseConfig);
    } else {
      firebaseApp = getApps()[0];
    }
  }
  return firebaseApp;
}

function getFirebaseAnalytics() {
  if (firebaseAnalytics !== undefined) {
    return firebaseAnalytics;
  }

  try {
    firebaseAnalytics = getAnalytics(getFirebaseApp());
  } catch (error) {
    firebaseAnalytics = null;
    if (import.meta.env.DEV) {
      console.warn("Firebase analytics is unavailable on web.", error);
    }
  }

  return firebaseAnalytics;
}

export function logAnalyticEvent(name: string, options?: { [key: string]: unknown }): void {
  const analytics = getFirebaseAnalytics();
  if (!analytics) return;

  return fbLogEvent(analytics, name, options);
}

export function setAnalyticUserId(userId: string | null) {
  const analytics = getFirebaseAnalytics();
  if (!analytics) return;

  setUserId(analytics, userId);
}

export function setAnalyticUserProperty(name: string, value: string | null) {
  const analytics = getFirebaseAnalytics();
  if (!analytics) return;

  setUserProperties(analytics, { [name]: value });
}
